export default "__VITE_ASSET__B7cEZ3cq__"